import { CartAddEvent } from '@theme/events';
import { prepareCartDrawerForAdd } from '@theme/cart-drawer-section';

function getVariantId(button) {
  const id = button.getAttribute('data-variant-id');
  const parsed = id ? Number(id) : NaN;
  return Number.isFinite(parsed) ? parsed : null;
}

function getCartSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
    .filter(Boolean);
}

/**
 * @param {number} variantId
 * @returns {Promise<Record<string, unknown>>}
 */
async function addVariantToCart(variantId) {
  const sections = getCartSectionIds().join(',');

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections,
      sections_url: window.location.pathname,
    }),
  });

  const data = await res.json();

  if (!res.ok || data.status) {
    const message =
      data.message ||
      (data.errors && typeof data.errors === 'object'
        ? Object.values(data.errors).flat().join(' ')
        : '') ||
      'Could not add this item to your cart.';
    throw new Error(message);
  }

  return data;
}

function setLoading(button, isLoading) {
  button.toggleAttribute('aria-busy', isLoading);
  button.disabled = isLoading;
}

document.addEventListener('click', async (e) => {
  const button = e.target instanceof Element ? e.target.closest('[data-cart-drawer-addon]') : null;
  if (!(button instanceof HTMLButtonElement)) return;

  const variantId = getVariantId(button);
  if (!variantId) return;

  const cartDrawer = document.querySelector('cart-drawer-component[auto-open]');
  prepareCartDrawerForAdd(cartDrawer);

  try {
    setLoading(button, true);
    const response = await addVariantToCart(variantId);

    document.dispatchEvent(
      new CartAddEvent(response, 'cart-drawer-add-ons', {
        source: 'cart-drawer-add-ons',
        itemCount: response.item_count ?? 0,
        sections: response.sections,
      })
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err instanceof Error && err.message) {
      button.setAttribute('aria-label', err.message);
    }
  } finally {
    setLoading(button, false);
    cartDrawer?.classList.remove('cart-drawer--pending');
  }
});
